// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__DdKEN","content":"styles_content__GqDkI","postfix":"styles_postfix__8A9kO"};